import AdminGroupIndex from '@/pages/admin/group/Index'
import AdminGroupAdd from '@/pages/admin/group/Add'
import AdminGroupEdit from '@/pages/admin/group/Edit'
import AdminGroupView from '@/pages/admin/group/View'

export default [
  {
    path: '/admin/group/add',
    name: 'AdminGroupAdd',
    component: AdminGroupAdd,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Добавление группы'
    }
  },
  {
    path: '/admin/group/edit/:id',
    name: 'AdminGroupEdit',
    component: AdminGroupEdit,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Изменение группы'
    }
  },
  {
    path: '/admin/group/:id',
    name: 'AdminGroupView',
    component: AdminGroupView,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Просмотр группы'
    }
  },
  {
    path: '/admin/group',
    name: 'AdminGroupIndex',
    component: AdminGroupIndex,
    meta: {
      roles: ['ROLE_ADMIN'],
      title: 'Список групп'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/group.js